import { MobileStepper } from '@mui/material'
import { Box } from '@mui/system'
import { ContentTypeChip } from 'Components/_common/ContentPreview/ContentTypeChip'
import { getMediaItems } from 'Components/SubmitMap/utils'
import React, { useEffect, useMemo, useState } from 'react'
import { Else, If, Then, When } from 'react-if'
import SwipeableViews from 'react-swipeable-views'
import FAIcon from 'Theme/FAIcon'

import AwardBadge from '../_common/AwardBadge'
import PlayersInfo from '../MapsComponents/PlayersInfo'
import YouTubeWithOverlay from './YouTubeWithOverlay'

const MobileGallery = ({ images = [], videos = [], categoryName, gameTypeName, content, type, iconClassName }) => {
  const [activeStep, setActiveStep] = useState(0)
  const [selectedGalleryItemIsVideo, setSelectedGalleryItemIsVideo] = useState(false)

  const galleryItems = useMemo(() => {
    if (!images) return
    const mappedImages = images?.map(({ urls }) => urls)
    return getMediaItems(mappedImages, videos)
  }, [images, videos])

  const handleStepChange = (step) => {
    setActiveStep(step)
  }

  useEffect(() => {
    if (galleryItems?.[activeStep]?.isVideo) {
      setSelectedGalleryItemIsVideo(true)
    } else {
      setSelectedGalleryItemIsVideo(false)
    }
  }, [activeStep, galleryItems, setSelectedGalleryItemIsVideo])

  return (
    <Box
      position="relative"
      marginTop="65px"
    >
      <When condition={!!content}>
        <AwardBadge
          settings={content}
          containerStyles={{ position: 'absolute', top: 10, left: 10, zIndex: 2 }}
        />
        <Box
          sx={{
            width: '70px',
            position: 'absolute',
            bottom: 10,
            right: 10,
            zIndex: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(20px)',
            borderRadius: 10,
          }}
        >
          <When condition={!selectedGalleryItemIsVideo}>
            <PlayersInfo
              categoryName={categoryName}
              gameType={gameTypeName}
            />
          </When>
        </Box>
        {type && !selectedGalleryItemIsVideo && (
          <Box
            sx={{
              position: 'absolute',
              bottom: 10,
              left: 10,
              zIndex: 2,
            }}
          >
            <ContentTypeChip
              label={type}
              icon={
                <FAIcon
                  iconClassName={iconClassName}
                  color="text.tertiary"
                  iconFontSize={10}
                />
              }
            />
          </Box>
        )}

        {galleryItems && galleryItems.length > 0 && (
          <SwipeableViews
            axis="x"
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
          >
            {galleryItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  position: 'relative',
                  display: 'block',
                  width: '100%',
                  height: '260px',
                  objectFit: 'cover',
                  overflow: 'hidden',
                }}
              >
                <If condition={item.isVideo}>
                  <Then>
                    <YouTubeWithOverlay
                      item={item}
                      index={index}
                      activeStep={activeStep}
                    />
                  </Then>
                  <Else>
                    <Box
                      sx={{
                        display: 'block',
                        width: '100%',
                        height: '260px',
                      }}
                      component={'img'}
                      id={item.src}
                      src={item.src}
                    />
                  </Else>
                </If>
              </Box>
            ))}
          </SwipeableViews>
        )}

        {galleryItems && galleryItems.length > 0 && (
          <MobileStepper
            steps={galleryItems.length}
            variant="dots"
            color="text.primary"
            sx={{
              position: 'absolute',
              bottom: '25px',
              height: '5px',
              backgroundColor: 'transparent',
              justifyContent: 'center',
              gap: '8px',
              '& .MuiMobileStepper-dot': {
                backgroundColor: '#8d8d8d',
                marginRight: '4px',
                marginLeft: '4px',
              },
              '& .MuiMobileStepper-dotActive': {
                backgroundColor: '#FAFAFB',
                transition: 'all .2s ease-in-out',
                transform: 'scale(1.2)',
                marginRight: '4px',
                marginLeft: '4px',
              },
            }}
            activeStep={activeStep}
          />
        )}
      </When>
    </Box>
  )
}

export default MobileGallery
